import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, defineAsyncComponent, watch } from 'vue'
import checkPc from '@/utils/checkPc'
import { isWxBrowser } from '@/utils/common'

/**
 * 判断是否PC端
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = checkPc()

// 引入组件
const LoginContainer = defineAsyncComponent(() => import('./components/PageContainer.vue'));

const formState = ref({
  tabList: [
    { name: '扫码登录', key: 'login-ewm' },
    { name: '密码登录', key: 'login-ps' }
  ],
  activeKey: 'login-ewm'
})


watch(
  () => isPC.value,
  () => {
    if (isPC.value) {
      formState.value.activeKey = 'login-ewm'
    } else {
      if (isWxBrowser()) {
        formState.value.tabList = [{ name: '微信登录', key: 'login-wx' }]
        formState.value.activeKey = 'login-wx'
      } else {
        formState.value.activeKey = 'login-ps'
      }
    }
  }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LoginContainer), { formState: formState.value }, null, 8, ["formState"]))
}
}

})